class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    this.mobileFilters = this.querySelector("#FacetFiltersFormMobile");

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;


    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      
      
      if (event.target.querySelector('[name="sort_by"]')) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("sort_by", event.target.querySelector('[name="sort_by"]').value);
        this.onSubmitForm(searchParams.toString(), event);
      } else if (event.target.classList.contains('filter--sort_by_dropdowns')) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("sort_by", event.target.closest('facet-filters-form').querySelector('[name="sort_by"]').value);
        this.onSubmitForm(searchParams.toString(), event);
      } else {
        this.onSubmitForm(forms.join("&"), event);
      }
    }
    if (typeof setupBackToTop === 'function') {
      setTimeout(function () {
        setupBackToTop();
      }, 1000);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}
document.addEventListener('DOMContentLoaded', function () {
  const filterButton = document.querySelector('.mobile-facets__open-wrapper'); // Change the selector to match your button or summary

  filterButton.addEventListener('click', function (event) {
    const filtersDrawer = document.querySelector('menu-drawer');
    const isOpen = filtersDrawer.hasAttribute('open');
    isOpen ? filtersDrawer.removeAttribute('open') : filtersDrawer.setAttribute('open', '');

  });

  // Close the drawer when clicking outside of it
  window.addEventListener('click', function (event) {
    const filtersDrawer = document.querySelector('menu-drawer');
    if (!event.target.closest('menu-drawer') && filtersDrawer.hasAttribute('open')) {
      filtersDrawer.removeAttribute('open');
    }
  });
});

const detailsElements = document.querySelectorAll(".mobile-facets__details");
detailsElements.forEach(function (detailsElement) {
  detailsElement.addEventListener("click", function () {
    setTimeout(() => { // Delay to ensure the open attribute is updated
      const headerElement = document.querySelector(".mobile-facets__header");
      if (detailsElement.open) {
        headerElement.classList.add("header-hide");
      } else {
        headerElement.classList.remove("header-hide");
      }
    }, 0);
  });
});
// Sort sidebar drawer
const openBtn = document.querySelector(".openbtn");
const closeBtn = document.querySelector(".closebtn");
const sidebar = document.querySelector(".sidebar");
const overlay = document.getElementById("overlay");

openBtn.addEventListener("click", function () {
  sidebar.classList.add("sidebar-open");
  document.body.classList.add("filter-open");
  overlay.style.display = "block";
});

closeBtn.addEventListener("click", function () {
  closeSidebar();
});

overlay.addEventListener("click", function () {
  closeSidebar();
});

function closeSidebar() {
  sidebar.classList.remove("sidebar-open");
  document.body.classList.remove("filter-open");
  overlay.style.display = "none";
  if (typeof setupBackToTop === 'function') {
    setTimeout(function () {
      setupBackToTop();
    }, 1000);
  }
}

// Get the sort sidebar and all label elements inside dropdown items inside sorting sidebar
const sort = document.querySelector('#sort-Sidebar');
const labels = sort.querySelectorAll('.dropdown__item label');
labels.forEach(e => {
  e.addEventListener('click', function () {
    e.querySelector('button').click();
  });
});

let buttons = document.querySelectorAll(".sort-apply-btn");
buttons.forEach(function (button) {
  button.addEventListener("click", function () {
    sidebar.classList.remove("sidebar-open");
    document.body.classList.remove("filter-open");
    document.getElementById("overlay").style.display = "none";
    if (typeof setupBackToTop === 'function') {
      setTimeout(function () {
        setupBackToTop();
      }, 1000);
    }
  });
});

const closeButton = document.querySelector(".mobile-facets__close");
const detailsElement = document.querySelector(".mobile-facets__disclosure");
function closeMobileFacet() {
  const closeButton = document.querySelector(".mobile-facets__close");
  const detailsElement = document.querySelector(".mobile-facets__disclosure");
  closeButton.addEventListener("click", function () {
    setTimeout(function () {
      detailsElement.classList.remove("menu-opening");
      closeButton.classList.add("filter-close-hide");
      document.body.classList.remove("filter-open");
    }, 200);
    if (typeof setupBackToTop === 'function') {
      setTimeout(function () {
        setupBackToTop();
      }, 1000);
    }
  });
  detailsElement.addEventListener("click", function () {
    if (detailsElement.classList.contains("menu-opening")) {
      setTimeout(function () {
        closeButton.classList.remove("filter-close-hide");
      }, 200);
    }

  });
}
closeMobileFacet();

// Select all input fields with the class "field__input" under elements with the class "field"
const inputElements = document.querySelectorAll('.field .field__input');
inputElements.forEach(function (inputElement) {
  // Add event listener to each input field to restrict input to digits 0 to 9 and backspace
  inputElement.addEventListener('keypress', function (event) {
    const keyCode = event.keyCode || event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
      event.preventDefault();
    }
  });
});

function closeFacetsMenu() {
  const closeButton = document.querySelector(".mobile-facets__close");
  closeButton.click();
  if (typeof setupBackToTop === 'function') {
    setTimeout(function () {
      setupBackToTop();
    }, 1000);

  }
}

customElements.define("facet-remove", FacetRemove);
